var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValidToggleButon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Valid_Toggle_Buton",
    "data-name": "Valid Toggle Buton",
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 31,
    viewBox: "0 0 81 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 81,
    height: 31,
    rx: 15.5,
    fill: "#278566"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(-937 -518.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(997 528.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 48,
    height: 20,
    transform: "translate(964 524.5)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M-7.891-9.061-11.31,0h-1.365l-3.419-9.061h1.261l2.847,7.813,2.847-7.813Zm.858,5.473a4,4,0,0,1,.442-1.918,3.207,3.207,0,0,1,1.216-1.28,3.334,3.334,0,0,1,1.722-.455,3.161,3.161,0,0,1,1.625.4A2.685,2.685,0,0,1-1-5.824v-1.3h1.2V0H-1V-1.326A2.787,2.787,0,0,1-2.048-.293a3.131,3.131,0,0,1-1.619.41A3.229,3.229,0,0,1-5.382-.351,3.282,3.282,0,0,1-6.591-1.664,4.089,4.089,0,0,1-7.033-3.588ZM-1-3.575a2.9,2.9,0,0,0-.325-1.4A2.3,2.3,0,0,0-2.2-5.9a2.391,2.391,0,0,0-1.215-.319A2.394,2.394,0,0,0-4.628-5.9a2.263,2.263,0,0,0-.871.91,2.9,2.9,0,0,0-.325,1.4A2.963,2.963,0,0,0-5.5-2.164a2.3,2.3,0,0,0,.871.923,2.356,2.356,0,0,0,1.209.319A2.391,2.391,0,0,0-2.2-1.242a2.285,2.285,0,0,0,.878-.923A2.934,2.934,0,0,0-1-3.575ZM3.38-9.62V0H2.2V-9.62ZM6.006-8.281a.778.778,0,0,1-.572-.234A.778.778,0,0,1,5.2-9.087a.778.778,0,0,1,.234-.572.778.778,0,0,1,.572-.234.742.742,0,0,1,.553.234.79.79,0,0,1,.227.572.79.79,0,0,1-.227.572A.742.742,0,0,1,6.006-8.281Zm.572,1.157V0H5.395V-7.124ZM8.151-3.588a4,4,0,0,1,.442-1.918,3.207,3.207,0,0,1,1.215-1.28,3.359,3.359,0,0,1,1.735-.455,3.222,3.222,0,0,1,1.547.384A2.767,2.767,0,0,1,14.183-5.85V-9.62h1.2V0h-1.2V-1.339a2.768,2.768,0,0,1-1.04,1.047,3.1,3.1,0,0,1-1.612.41A3.263,3.263,0,0,1,9.808-.351,3.267,3.267,0,0,1,8.593-1.664,4.089,4.089,0,0,1,8.151-3.588Zm6.032.013a2.9,2.9,0,0,0-.325-1.4A2.3,2.3,0,0,0,12.98-5.9a2.391,2.391,0,0,0-1.215-.319,2.394,2.394,0,0,0-1.209.312,2.263,2.263,0,0,0-.871.91,2.9,2.9,0,0,0-.325,1.4,2.963,2.963,0,0,0,.325,1.424,2.3,2.3,0,0,0,.871.923,2.356,2.356,0,0,0,1.209.319,2.391,2.391,0,0,0,1.215-.319,2.285,2.285,0,0,0,.878-.923A2.934,2.934,0,0,0,14.183-3.575Z",
    transform: "translate(988 538.5)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidToggleButon);
export default __webpack_public_path__ + "static/media/ValidToggleButon.e33d88b0c6b95378b73fd625241b50ca.svg";
export { ForwardRef as ReactComponent };